module.exports = __webpack_public_path__ + "img/3.fe97cc10.png";